<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 9L17 15M17 9L11 15M8.91987 19H20C21.1046 19 22 18.1046 22 17V7C22 5.89543 21.1046 5 20 5H8.91987C8.33602 5 7.78132 5.25513 7.40136 5.69842L2.55782 11.3492C2.23683 11.7237 2.23683 12.2763 2.55782 12.6508L7.40136 18.3016C7.78132 18.7449 8.33602 19 8.91987 19Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
